export const detectIE = () => {
  return typeof window !== 'undefined' && /Trident\/|MSIE/.test(window.navigator.userAgent);
};

export const detectEdgeHtml = () => {
  return (
    typeof window !== 'undefined' &&
    /edge\/([0-1][0-8]|[0-9]\D)/.test(window.navigator.userAgent.toLowerCase())
  );
};

export const isSafari = () => {
  return (
    typeof window !== 'undefined' &&
    (/constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === '[object SafariRemoteNotification]';
      })(!window['safari'] || window.safari.pushNotification))
  );
};

export const isMobileSafari = () => {
  return typeof window !== 'undefined' && /iP(ad|od|hone)/i.test(window.navigator.userAgent);
};

export const isAndroid = () => {
  return typeof window !== 'undefined' && /android/i.test(window.navigator.userAgent.toLowerCase());
};
